/**
 * Custom Link Resolvers
 *
 * Project-specific handlers for special link patterns.
 * Used by SmartLink component in @/app/_components/core/smart-link.
 */

// Import directly from the source module, not the @custom/_exports barrel: the
// barrel re-exports this file too, so going through it forms an import cycle.
import type { LinkResolver } from '@/app/_components/core/smart-link';
import { cn } from '@/app/_lib/utils';
import { consentManagerAdapter } from '@custom/consent-manager';

export const customLinkResolvers: LinkResolver[] = [
  // Consent renewal (provider-agnostic via adapter)
  {
    pattern: /^cookie:renew$/,
    render: ({ title, className, children }) => (
      <button
        type="button"
        onClick={() => { consentManagerAdapter.openConsentDialog(); }}
        className={cn(
          'cursor-pointer appearance-none border-0 bg-transparent p-0 text-inherit',
          className
        )}
        data-track-id="cookie-settings"
      >
        {children ?? title}
      </button>
    ),
  },
];
